<template>
  <a-menu
    class="page_menu"
    v-model:selectedKeys="menuActiveKey"
    mode="horizontal"
    @select="handleMenuClick"
  >
    <a-menu-item v-for="item in menuList" :key="item.key"> {{ item.name }} </a-menu-item>
  </a-menu>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from "vue";
const props = defineProps({
  menuList: {
    type: Array,
    default: () => []
  },
  activeKey: {
    type: String,
    default: ""
  }
});
const emits = defineEmits(["handleMenuClick", "update:activeKey"]);
const menuActiveKey = ref([]);
const handleMenuClick = ({ key }) => {
  emits("update:activeKey", key);
  emits("handleMenuClick", key);
};

watch(
  () => props.activeKey,
  (val) => {
    menuActiveKey.value = [val];
  },
  { immediate: true }
);
</script>

<style scoped lang="less">
.page_menu {
  :deep(.ant-menu-item) {
    padding: 0 24px;
  }
}
</style>
